module.exports = __webpack_public_path__ + "static/website-builder-06dfcebb4794b15e5094e6984caacbef.png";